import Vue from 'vue'
import router from '@/router'
import store from '@/store'
import NProgress from 'nprogress'
import {getLocalItem,getQueryString} from '@/utils'
import '@/style/nprogress.less'
import Client from 'esdk-obs-browserjs'
NProgress.configure({ showSpinner: false })
const whiteList = ['Login']
const routerMenu: any = []
router.beforeEach((to: any, from, next) => {
  NProgress.start()
  const urlHasToken = !!to.query.userToken
  // 61084abaa5c428a1a6268ae9037a6cdf
  if (urlHasToken) {
    Vue.ls.set('ACCESS_TOKEN', to.query.userToken, 2 * 60 * 60 * 1000)
    store.dispatch('user/GetUserInfo').then(res => {
      if (res && res.status === 0) {
        localStorage.setItem('client', JSON.stringify(res.data))
        next({ path:'/home' })
      } else {
        next({ path: '/user/login' })
      }
    })
    NProgress.done()
  } else {
    const hasToken = !!Vue.ls.get('ACCESS_TOKEN')
    
    if (hasToken) {
      if (to.path === '/user/login') {
        next('/')
        NProgress.done()
      } else {
        store.dispatch('user/GetUserInfo').then(res => {
          if (res && res.status === 0) {
            localStorage.setItem('client', JSON.stringify(res.data))
            next()
            NProgress.done()
          } else {
            Vue.ls.clear()
            next({ path: '/user/login' })
            NProgress.done()
          }
        })
        NProgress.done()
      }
    } else {
      if (whiteList.includes(to.name)) {
        // 白名单免登录
        next()
      } else {
        // 否则跳到登录页
        next({ path: '/user/login' })
        NProgress.done()
      }
    }
  }
})

router.afterEach((to: any, from) => {
  NProgress.done()
})
export default function roMenu() {
  return routerMenu
}
